import { lazy } from "react";
import { routes } from "../../../../common/routes";

type iDataList = {
  title: string;
  style: string;
  Icon: React.LazyExoticComponent<React.ComponentType<any>>;
  link?: string;
  name: string;
  catid?: string;
};

const loadIcon = (path: string) =>
  lazy(() => import(`../../../../static/Icons/${path}`));

export const datalist: Record<string, iDataList> = {
  WALLET_TRANSFER: {
    title: "Wallet Transfer",
    style: "bg-blue-30 text-blue-20",
    Icon: loadIcon("WalletIcon"),
    link: routes.wallet_transfer,
    name: "WALLET_TRANSFER",
  },
  BANK_TRANSFER: {
    title: "Bank Transfer",
    style: "bg-pink-20 text-pink-10",
    Icon: loadIcon("MoneySendIcon"),
    link: routes.bank_transfer.index,
    name: "BANK_TRANSFER",
  },
  FUND_WALLET: {
    title: "Fund Wallet",
    style: "bg-peach-20 text-peach-10",
    Icon: loadIcon("WalletAddIcon"),
    link: routes.fund_wallet.initialform,
    name: "FUND_WALLET",
  },
  GIFT_CARDS: {
    title: "Gift Cards",
    style: "bg-yellow-20 text-yellow-10",
    Icon: loadIcon("CardPosIcon"),
    // link: routes.gift_card,
    name: "GIFT_CARDS",
  },
  SUBSCRIPTION: {
    title: "Subscription Services",
    style: "bg-green-20 text-green-10",
    Icon: loadIcon("KeyboardOpenIcon"),
    link: routes.subscription_services.dashboard,
    name: "SUBSCRIPTION",
  },
  UTILITIES: {
    title: "Utilities",
    style: "bg-lime-20 text-lime-10",
    Icon: loadIcon("LampIcon"),
    name: "UTILITIES",
    link: routes.utility.all,
  },
  AIRTIME: {
    title: "Airtime",
    style: "bg-red-20 text-red-10",
    Icon: loadIcon("AirtimeIcon"),
    name: "AIRTIME",
    link: routes.utility.dynamic_type.index,
    catid: "645cf2e0a97fd6ba20cbc297",
  },
  DATA: {
    title: "Data",
    style: "bg-purple-20 text-purple-10",
    Icon: loadIcon("DataIcon"),
    name: "DATA",
    link: routes.utility.dynamic_type.index,
    catid: "645cf2e3a97fd6ba20cbc2a0",
  },
  SAVINGS: {
    title: "Savings",
    style: "bg-gold-20 text-gold-10",
    Icon: loadIcon("SavingsIcon"),
    name: "SAVINGS",
  },
  INVESTMENT: {
    title: "Investment",
    style: "bg-gray-20 text-gray-10",
    Icon: loadIcon("InvestmentIcon"),
    name: "INVESTMENT",
  },
};
